import "./styles.scss";
import lang from "./lang";

const PaymentDetailsForm = ({
  isLoading,
  isCard,
  isPhonePristine,
  isPhoneValid,
  paymentMethod,
  setPaymentMethod,
  phone,
  setPhone,
  checkouts,
  defaultPaymentMethod,
  globals,
  authUser,
}) => {
  const sanitizePhone = (number) => `+${number?.replace(/\D?/g, "")}`;

  return (
    <>
      <h2 className="header-cta">{lang?.nowChoosePaymentMethod}</h2>
      <div
        className={`loading-overlay ${isLoading ? "loading" : ""}`}
        onMouseDown={(e) => {
          // avoid moving the slide when selecting the phone text
          e.stopPropagation();
        }}
      >
        <span id="announcement-overlay" className="announcement-overlay">
          {paymentMethod?.ikPaymentMethod === 'card' ? lang?.redirectingToPaymentPartner: lang?.waitASec}
        </span>
      </div>
      <div className={`payment-details-form ${isLoading ? "loading" : ""}`}>
        <div className="switcher">
          <div
            className={`switcher-item ${isCard && "active"}`}
            onClick={() => {
              setPaymentMethod(defaultPaymentMethod);
            }}
            onKeyDown={(e) => {
              if (e?.keyCode === 13 || e?.keyCode === 32) {
                e?.preventDefault();
                setPaymentMethod(defaultPaymentMethod);
              }
            }}
            tabIndex="0"
          >
            {lang?.paymentCard}
          </div>
          <div
            className={`switcher-item ${
              paymentMethod?.name === "transfer" && "active"
            }`}
            onClick={() =>
              setPaymentMethod(
                checkouts?.filter((c) => c?.name === "transfer")[0]
              )
            }
            onKeyDown={(e) => {
              if (e?.keyCode === 13 || e?.keyCode === 32) {
                e?.preventDefault();
                setPaymentMethod(
                  checkouts?.filter((c) => c?.name === "transfer")[0]
                );
              }
            }}
            tabIndex="0"
          >
            {lang?.transfer}
          </div>
          {null && (
            <div
              className={`switcher-item ${
                paymentMethod?.name === "privat24" && "active"
              }`}
              onClick={() =>
                setPaymentMethod(
                  checkouts?.filter((c) => c?.name === "privat24")[0]
                )
              }
              onKeyDown={(e) => {
                if (e?.keyCode === 13 || e?.keyCode === 32) {
                  e?.preventDefault();
                  setPaymentMethod(
                    checkouts?.filter((c) => c?.name === "privat24")[0]
                  );
                }
              }}
              tabIndex="0"
            >
              {lang?.privat24}
            </div>
          )}
          {(!globals?.env?.isProd || authUser?.isAdmin) && (
            <div
              className={`switcher-item ${
                paymentMethod?.name === "test" && "active"
              }`}
              onClick={() =>
                setPaymentMethod(
                  checkouts?.filter((c) => c?.name === "test")[0]
                )
              }
            >
              {lang?.test}
            </div>
          )}
        </div>
        <div className={`content ${isLoading ? "loading" : ""}`}>
          {isCard && (
            <>
              <div>
                <strong>{lang?.anyPaymentCard}</strong>
              </div>
              <ol className="ordered-list">
                <li>{lang?.prepareYourCellPhone}</li>
                <li>{lang?.makeSureCardIsActive}</li>
                <li>{lang?.fillInTheForms}</li>
              </ol>
            </>
          )}
          {paymentMethod?.name === "transfer" && (
            <>
              <div>
                <strong>{lang?.accountTransfer}</strong>
              </div>
              <ol className="ordered-list">
                <li>{lang?.fillInTheForm}</li>
                <li>{lang?.getTheOrderNumber}</li>
                <li>{lang?.payInBankOrOnline}</li>
              </ol>
            </>
          )}
          {paymentMethod?.name === "privat24" && (
            <>
              <div>
                <strong>{lang?.ifPrivat24Client}</strong>
              </div>
              <ol className="ordered-list">
                <li>{lang?.prepareYourPassword}</li>
                <li>{lang?.prepareYourCellPhoneForSms}</li>
                <li>{lang?.fillInTheForm}</li>
              </ol>
            </>
          )}
          <div className="phone-number">
            <strong className="caption">{lang?.yourPhoneNumber}</strong>
            <div className="phone-number-input">
              <input
                type="tel"
                name="phone"
                className="phone-number-input-field"
                placeholder={lang?.yourPhoneNumberPlaceholder}
                value={phone || ""}
                onChange={(e) => {
                  setPhone(sanitizePhone(e?.target?.value));
                }}
                onMouseDown={(e) => {
                  // avoid moving the slide when selecting the phone text
                  e.stopPropagation();
                }}
                disabled={isLoading}
                tabIndex="0"
              />
              <span className="span">
                {isPhonePristine || isPhoneValid() ? (
                  lang?.soWeCanContactYou
                ) : (
                  <span className="error">{lang?.phoneIsInvalid}</span>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="footer">
          {isCard
            ? lang?.secureConnectionPayment
            : lang?.openingLessonsOnRequest}
        </div>
      </div>
    </>
  );
};

export default PaymentDetailsForm;
